export default {

    init() {
        // TOGGLE FORM
        const form = document.getElementsByClassName('form-dropdown')[0]

        if (! form) {
            return
        }

        const toggle = form.querySelector('.form-dropdown__toggle')

        toggle.addEventListener('click', function(e) {
            form.classList.toggle('open')
        })
    }
}